import { SharedService } from './../../services/shared.service';
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Tabs, Views } from '../../../environments/common';
import { SessionService } from '../common/session/session.service';
import { UtilsService } from '../utils/utils.service';
import { CatalogueService } from '../catalogue/catalogue.service';
import { LanguagesService } from '../languages/languages.service';
import { TranslateService } from '@ngx-translate/core';
import { LoginService } from '../login/login.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalLoginComponent } from '../modal-login/modal-login.component';
import { DetailsService } from '../details/details.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent {
  
  selector = {
    tabs: Tabs.ONLY_EXHIBITORS,
    views: Views.LIST,
    event: ''
  };

  loader: any = { count: 0 };
  alertType: string = '';
  alertMessage: string = '';

  public tabs = Tabs;
  event: string | null;

  favorites: boolean = false;

  currentUrl: string;
  fullUrl: string = '';
  eventData:any = null;
  published: boolean = false;
  
  availableLanguages: Array<any> = ["en","es","ca"];

  
  constructor(private activatedRoute: ActivatedRoute, private sharedService:SharedService, private sessionService: SessionService,
    private catalogueService: CatalogueService, private utilsService: UtilsService, private languageService:LanguagesService, 
    public translateService: TranslateService, private router: Router, private loginService:LoginService, private modalService: NgbModal,
    private detailsService: DetailsService){

  }
  
  findByEventName(findByEventNameIn) {

    this.loader.count++;
    this.alertType = '';
    this.alertMessage = '';

    this.catalogueService.findByEventName(findByEventNameIn)
      .subscribe((data: object) => {
        this.findByEventNameOk(data);
      },
        error => {
          this.findByEventNameError(error);
        });

  }

  findByEventNameOk(data) {

    this.loader.count--;
    this.sessionService.set('eventData', data, false);
    this.sessionService.set('eventData_' + data['eventName'], data, true);
    this.sessionService.set('catalogId', data['id'], false);
    this.catalogueService.setData(data);

    this.executeDetails();

    this.utilsService.setCatalogueProperties(data);
    this.utilsService.checkTab('filterExhibitors', data);
    this.published = data?.published;  

    this.sharedService.updateUrl();

    this.languageService.getCatalogueDefaultLanguages(data['id']).subscribe((languages) => {

        // Asegurarse de que 'languages' sea un string
      let lang: string;
      if (typeof languages === 'string') {
        lang = languages;
      } else if (languages && languages.toString) {
        lang = languages.toString();
      } else {
        console.error("[getCatalogueDefaultLanguages]ERROR: El valor recibido no es un string y no se puede convertir");
        return;
      }
      
      this.translateService.setDefaultLang(this.utilsService.getLanguageShortISO(lang));
      
      // Verificar si hay un parámetro lang en la URL
      this.activatedRoute.queryParams.subscribe(params => {
        const urlLang = params['lang'];
        if (urlLang) {
          // Si hay un idioma en la URL, usarlo en lugar del por defecto
          const shortUrlLang = this.utilsService.getLanguageShortISO(urlLang);
          if (this.utilsService.isValidLanguage(shortUrlLang)) {
            this.translateService.use(shortUrlLang);
            console.log('Usando idioma de la URL: ', shortUrlLang);
          }
        } else {
          // Solo usar el idioma por defecto si no hay parámetro en la URL
          console.log('this.translateService.currentLang: ', this.translateService.currentLang);
          console.log('this.translateService.getDefaultLang: ', this.translateService.getDefaultLang());
          if(this.translateService.currentLang === this.translateService.getDefaultLang())
            this.translateService.currentLang = this.utilsService.getLanguageShortISO(lang);
        }
      });

      if(!data?.published){
        if (this.loginService.isAuth()) {
          this.goAdmin(data?.eventName);
        }
        else{
          const modalRef = this.modalService.open(ModalLoginComponent);
          modalRef.result.then((result) => {
            this.goAdmin(data?.eventName);
          }, (reason) => {
            //console.log('Modal dismissed with:', reason);
          });
        }


      }
    },
    error => {
      console.error("[getCatalogueDefaultLanguages]ERROR", error);
    });

    this.getAvailableLang();

  }

  executeDetails() {
    let getDetailsJsonIn = {
      sapCode: this.catalogueService.getProperty('sapCode')
    };
    this.getDetailsJson(getDetailsJsonIn);
    this.getDetailsJson(getDetailsJsonIn, true);
  }

  findByEventNameError(error) {

    let alertData = {
      alertType: 'error',
      alertMessage: error.message
    }

    this.loader.count--;
    this.alertType = alertData.alertType;
    this.alertMessage = alertData.alertMessage;
    this.detailsService.setIsUpdateDetails(true);

  }

  goAdmin(eventName){
    let queryParams = {};
    let url = eventName + '/exhibitor-backoffice/util-info';
    this.router.navigate([url], { queryParams: queryParams });
  }

  

  getDetailsJson(getDetailsJsonIn, local = false) {

    this.loader.count++;
    this.alertType = '';
    this.alertMessage = '';

    this.detailsService.getDetailsJson(getDetailsJsonIn, local)
      .subscribe((data: object) => {
        this.getDetailsJsonOk(data, local);
      },
        error => {
          this.getDetailsJsonError(error);
        });

  }

  getDetailsJsonOk(data, local) {

    this.loader.count--;
    this.detailsService.setDetailsJson(data, local);
    this.detailsService.setIsUpdateDetails(true);

  }

  getDetailsJsonError(error) {

    let alertData = {
      alertType: 'error',
      alertMessage: error.message
    }

    this.loader.count--;
    this.alertType = alertData.alertType;
    this.alertMessage = alertData.alertMessage;
    this.detailsService.setIsUpdateDetails(true);

    //if(!this.selectedView)
      //this.filtersService.setSelectedView(this.defaults.views.toLocaleLowerCase());

  }

  getLocale(lang:string){
    switch(lang){
      case 'en':
        return 'en_GB';
        break;
      case 'ca':
        return 'ca_ES';
        break;
      default: return 'es_ES';
    }
  }

  getCustomCatalogueTranslations(){
    
    for (let i = 0; i < this.availableLanguages.length; i++) {
        if (this.availableLanguages[i]) {
            let dataIn = {
                sapCode: this.catalogueService.getProperty('sapCode'),
                lang: this.getLocale(this.availableLanguages[i])
            };
            this.languageService.getRemoteCustomTranslationsJson(dataIn).subscribe(
                (data) => {
                  if (!this.utilsService.isEmptyObject(data))
                    this.sessionService.set('customTranslations_' + dataIn.sapCode + '_' + this.availableLanguages[i], data);
                },
                (error) => {
                    console.error("[getCustomCatalogueTranslations]ERROR", error);
                }
            );
        } else {
            console.warn("[getCustomCatalogueTranslations]WARNING: this.availableLanguages[" + i + "] is undefined");
        }
    }
  }
  
  getAvailableLang(){

    let catalogueId = this.catalogueService.getProperty('id');

    this.languageService.getCatalogueLanguages(catalogueId).subscribe((languages) => {
          const languagesArray: string[] = Object.values(languages);
          let appLanguages = languagesArray.map(value => {
            return this.utilsService.getLanguageShortISO(value); // Obtener los primeros dos caracteres
          });
          this.availableLanguages = appLanguages;
          this.sessionService.set('availableLanguages', this.availableLanguages, false);
          this.sessionService.set('availableLanguagesLong', languages, false);

          this.getCustomCatalogueTranslations();

          console.log("[getAvailableLang:languages]", languages);

        },
        error => {
          console.error("[getCatalogueLanguages]ERROR", error);
        });

    console.log("[getAvailableLang:catalogueId]ERROR", catalogueId);
  }



  ngOnInit(){

    let findByEventNameIn = {
      eventCode: ''
    };
    
    this.activatedRoute.paramMap.subscribe(params => {
      const eventParam = params['event'];
      this.selector.event = eventParam !== null && eventParam !== undefined ? eventParam : '';
    });
    
    this.activatedRoute.queryParams.subscribe(params  => {
      const tab = params['tab'];
      this.favorites = tab === 'favorites';
      this.selector.tabs = this.utilsService.isEmpty(params['filter'])?this.selector.tabs:params['filter'];
    });

    findByEventNameIn.eventCode = document.location.pathname.split('/')[1];

    this.sessionService.set('eventName', findByEventNameIn.eventCode, false);

    this.findByEventName(findByEventNameIn);

    
    this.detailsService.getIsUpdateDetails().subscribe(update => {
      let eventData = JSON.parse(this.sessionService.get('eventData', false) || '{}');
      this.utilsService.setColors(eventData);
    });

  }




}
